import { Routes, Route, useLocation } from 'react-router-dom';
import { lazy, Suspense, useEffect, Component } from 'react';
import { listenSystemThemeChange } from './utill/utill';
import NotFound from './utill/NotFound';

class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    console.error('ErrorBoundary caught:', error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div style={{
          display: 'flex', flexDirection: 'column', alignItems: 'center',
          justifyContent: 'center', height: '100vh', gap: '16px',
          fontFamily: 'var(--font-sans, Pretendard, sans-serif)',
          color: 'var(--text-primary, #1a1a2e)',
          background: 'var(--background, #fff)',
        }}>
          <svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="var(--danger-500, #ef4444)" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <circle cx="12" cy="12" r="10" />
            <line x1="12" y1="8" x2="12" y2="12" />
            <line x1="12" y1="16" x2="12.01" y2="16" />
          </svg>
          <h2 style={{ margin: 0, fontSize: '18px' }}>오류가 발생했습니다</h2>
          <p style={{ margin: 0, fontSize: '14px', color: 'var(--text-secondary, #6b7280)' }}>
            페이지를 새로고침해 주세요.
          </p>
          <button
            onClick={() => window.location.reload()}
            style={{
              padding: '10px 24px', borderRadius: 'var(--radius-md, 6px)',
              border: 'none', background: 'var(--primary-600, #9333ea)',
              color: '#fff', fontSize: '14px', cursor: 'pointer',
            }}
          >
            새로고침
          </button>
        </div>
      );
    }
    return this.props.children;
  }
}

// 비로그인 진입 페이지 (Landing)
const LandingHomeBefore = lazy(() => import('./features/landing/LandingHomeNew'));

const LandingHome1 = lazy(() => import('./features/landing/LandingHomeView1'));
const LandingHome2 = lazy(() => import('./features/landing/LandingHomeNew2'));

const LandingNotice = lazy(() => import('./features/landing/LandingNotice'));
const LandingPrice = lazy(() => import('./features/landing/LandingPrice'));
const LandingClasses = lazy(() => import('./features/landing/LandingClasses'));
const LandingSupport = lazy(() => import('./features/landing/LandingSupport'));
const G2bSearch = lazy(() => import('./features/landing/G2bSearch'));

/* 라우트 전환 시 스크롤을 맨 위로 — SPA 기본은 스크롤 위치를 유지하므로,
   랜딩(window 스크롤 사용) 하단에서 이동하면 목적지가 내려간 채 보이는 문제를 막는다. */
function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
}

export default function App() {
  useEffect(() => {
    const cleanup = listenSystemThemeChange();
    return cleanup;
  }, []);

  return (
    <ErrorBoundary>
      <ScrollToTop />
      <Suspense fallback={null}>
        <Routes>

          <Route path="/" element={<LandingHome1 />} />
          <Route path="/home-v2" element={<LandingHome2 />} />

          <Route path="/homeBefore" element={<LandingHomeBefore />} />


          <Route path="/g2b" element={<G2bSearch />} />
          <Route path="/notice" element={<LandingNotice />} />
          <Route path="/notices/:id" element={<LandingNotice />} />
          <Route path="/pricing" element={<LandingPrice />} />
          <Route path="/classes" element={<LandingClasses />} />
          <Route path="/support" element={<LandingSupport />} />

          {/* 404 */}
          <Route path="*" element={<NotFound />} />

        </Routes>
      </Suspense>
    </ErrorBoundary>
  );
}
